export default function quoteForm() {
  const btnQuote = document.querySelector('#demandeDevis');
  const quoteForm = document.querySelector('.form-quote-request');
  const quoteFormInputs = Array.from(document.querySelectorAll('.form-quote-request .wpcf7-form-control'));

  if (btnQuote) {
    btnQuote.addEventListener('click', function() {
      quoteForm.classList.toggle('display-form');

      setTimeout(function() {
        quoteForm.classList.toggle('show-form');
      }, 100);
    });
    // btnQuote.addEventListener('mouseover', function() {
    //   quoteForm.classList.toggle('show-form');
    // });

    // Modifie le tabindex des <a> pour les rendre navigable au clavier
    quoteFormInputs.forEach(function(quoteFormInput) {
      quoteFormInput.setAttribute('tabindex', 0);
    });
  }
}
